import type { SyncedKitchenDisplayOrder } from '@/types/api';

interface KitchenDisplayOrderFormProps {
  formData: Partial<SyncedKitchenDisplayOrder>;
  onChange: (data: Partial<SyncedKitchenDisplayOrder>) => void;
}

export function KitchenDisplayOrderForm({ formData, onChange }: KitchenDisplayOrderFormProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
        <input type="text" value={formData.name || ''} onChange={(e) => onChange({ ...formData, name: e.target.value })} className="input w-full" required />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="flex items-center">
          <input type="checkbox" id="kdo-isEnabled" checked={formData.isEnabled ?? true} onChange={(e) => onChange({ ...formData, isEnabled: e.target.checked })} className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500" />
          <label htmlFor="kdo-isEnabled" className="ml-2 text-sm text-gray-700">Enabled</label>
        </div>
        <div className="flex items-center">
          <input type="checkbox" id="kdo-isDefaultDisplay" checked={formData.isDefaultDisplay ?? false} onChange={(e) => onChange({ ...formData, isDefaultDisplay: e.target.checked })} className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500" />
          <label htmlFor="kdo-isDefaultDisplay" className="ml-2 text-sm text-gray-700">Default Display</label>
        </div>
        <div className="flex items-center">
          <input type="checkbox" id="kdo-isWhenReady" checked={formData.isWhenReady ?? false} onChange={(e) => onChange({ ...formData, isWhenReady: e.target.checked })} className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500" />
          <label htmlFor="kdo-isWhenReady" className="ml-2 text-sm text-gray-700">When Ready</label>
        </div>
        <div className="flex items-center">
          <input type="checkbox" id="kdo-isAllTogether" checked={formData.isAllTogether ?? false} onChange={(e) => onChange({ ...formData, isAllTogether: e.target.checked })} className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500" />
          <label htmlFor="kdo-isAllTogether" className="ml-2 text-sm text-gray-700">All Together</label>
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Order No</label>
        <input type="number" value={formData.orderNo ?? ''} onChange={(e) => onChange({ ...formData, orderNo: parseInt(e.target.value) || 0 })} className="input w-full" />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Button Color</label>
          <div className="flex items-center gap-2">
            <input
              type="color"
              value={formData.buttonColorCode != null ? '#' + (formData.buttonColorCode >>> 0).toString(16).padStart(6, '0').slice(-6) : '#ffffff'}
              onChange={(e) => onChange({ ...formData, buttonColorCode: parseInt(e.target.value.slice(1), 16) })}
              className="h-9 w-14 cursor-pointer rounded border border-gray-300 p-0.5"
            />
            <input
              type="text"
              value={formData.buttonColorCode != null ? '#' + (formData.buttonColorCode >>> 0).toString(16).padStart(6, '0').slice(-6) : ''}
              onChange={(e) => {
                const hex = e.target.value.replace('#', '');
                if (/^[0-9a-fA-F]{0,6}$/.test(hex)) {
                  onChange({ ...formData, buttonColorCode: hex.length === 6 ? parseInt(hex, 16) : undefined });
                }
              }}
              placeholder="#ffffff"
              className="input w-full"
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Text Color</label>
          <div className="flex items-center gap-2">
            <input
              type="color"
              value={formData.textColorCode != null ? '#' + (formData.textColorCode >>> 0).toString(16).padStart(6, '0').slice(-6) : '#000000'}
              onChange={(e) => onChange({ ...formData, textColorCode: parseInt(e.target.value.slice(1), 16) })}
              className="h-9 w-14 cursor-pointer rounded border border-gray-300 p-0.5"
            />
            <input
              type="text"
              value={formData.textColorCode != null ? '#' + (formData.textColorCode >>> 0).toString(16).padStart(6, '0').slice(-6) : ''}
              onChange={(e) => {
                const hex = e.target.value.replace('#', '');
                if (/^[0-9a-fA-F]{0,6}$/.test(hex)) {
                  onChange({ ...formData, textColorCode: hex.length === 6 ? parseInt(hex, 16) : undefined });
                }
              }}
              placeholder="#000000"
              className="input w-full"
            />
          </div>
        </div>
      </div>
      {formData.buttonColorCode != null && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Preview</label>
          <div
            className="rounded px-4 py-2 text-center font-medium"
            style={{
              backgroundColor: '#' + ((formData.buttonColorCode ?? 0xffffff) >>> 0).toString(16).padStart(6, '0').slice(-6),
              color: '#' + ((formData.textColorCode ?? 0) >>> 0).toString(16).padStart(6, '0').slice(-6),
            }}
          >
            {formData.name || 'Kitchen Display Order'}
          </div>
        </div>
      )}
    </div>
  );
}
